import React from 'react';

import SelectableElement, { TSelectableElement } from '@r1-frontend/service-engineer-visit/components/SelectableElement';

import * as S from './styled';

export type TDayItemProps = {
    weekday: string,
    day: string | number,
    onClick: () => void,
} & TSelectableElement;

const DayItem = ({ weekday, day, ...props }: TDayItemProps): JSX.Element => {
    return <SelectableElement {...props}>
        <S.DayItem>
            <S.Child>{day}</S.Child>
            <S.Child>{weekday}</S.Child>
        </S.DayItem>
    </SelectableElement>;
};


export default DayItem;
